import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="24" viewbox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z" fill="#E5EBEF"></path><path d="M15.98 10.537c-.015 1.26 1.123 1.962 1.981 2.38.881.429 1.177.704 1.174 1.087-.007.587-.703.846-1.355.856-1.136.018-1.797-.307-2.323-.552l-.409 1.916c.527.243 1.503.455 2.516.464 2.375 0 3.93-1.173 3.939-2.992.009-2.308-3.193-2.435-3.171-3.467.007-.313.306-.647.96-.732.324-.042 1.218-.075 2.23.391l.398-1.854a6.078 6.078 0 0 0-2.117-.388c-2.236 0-3.81 1.19-3.822 2.891Zm9.762-2.73c-.434 0-.8.252-.963.64l-3.394 8.105h2.374l.473-1.306h2.902l.274 1.306H29.5l-1.826-8.746h-1.932Zm.332 2.362.685 3.284h-1.877l1.192-3.284ZM13.102 7.806l-1.872 8.746h2.263l1.87-8.746h-2.261Zm-3.347 0L7.4 13.76l-.953-5.062c-.112-.565-.553-.89-1.043-.89h-3.85L1.5 8.06c.79.172 1.688.448 2.232.744.333.181.428.34.538.769l1.804 6.979h2.391l3.666-8.746H9.755Z" fill="#1A1F71"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
